<h2 mat-dialog-title>{{dialogTitle}}</h2>
<mat-dialog-content>
    <div class="flex-content">
        <!-- Table -->

        <mat-table #tableContainerRef [dataSource]="tylerMatData" multiTemplateDataRows>

            <ng-container matColumnDef="CheckAllStatus">
                <mat-header-cell *matHeaderCellDef>
                    <tyl-checkbox id='chkForm' name="chkForm" (change)="checkAllForm()"
                    [(checked)]="allCheck">
                </tyl-checkbox>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    <tyl-checkbox (change)="checkBoxClick(element)" [(checked)]="element.StatusChecked" >
                    </tyl-checkbox>
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="TemplateName">
                <mat-header-cell *matHeaderCellDef>
                    <span translate>Form Name</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element">
                    {{element.TemplateName}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="Version">
                <mat-header-cell *matHeaderCellDef>
                    <span translate>Version</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let detail" style="margin-left: 30px;padding-left: 30px;">
                    {{detail.Version}}
                </mat-cell>
            </ng-container>

            <ng-container matColumnDef="IsOptional">
                <mat-header-cell *matHeaderCellDef>
                    <span translate>Optional</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="margin-left: 30px;">
                    {{element.IsOptional == true ? 'Y' : ''}} </mat-cell>
            </ng-container>

            <ng-container matColumnDef="IsAllowMultiple">
                <mat-header-cell *matHeaderCellDef>
                    <span translate>Allow Multiple</span>
                </mat-header-cell>
                <mat-cell *matCellDef="let element" style="margin-left: 30px;">
                    {{element.IsAllowMultiple == true ? 'Y' : ''}} </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="columnToDisplay; sticky: true" id="fieldsWithinFormsHeader">
            </mat-header-row>
            <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" id="fieldsWithinFormsRow{{i}}"
                tabindex="0" style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple class="element-row">
            </mat-row>
        </mat-table>
    </div>
</mat-dialog-content>

<mat-dialog-actions class="sis-app-footer" style="position: sticky; padding: 0px;">
    <div class="flex-footer-left">
    </div>
    <div class="flex-footer-right">
        <tyl-button id="saveButton" image="Save.png" label="Save and Close" (clickEvent)="saveClick()"></tyl-button>
        <tyl-button id="cancelButton" [label]="'Cancel'" image="Cancel.png" (clickEvent)="closeClick()"></tyl-button>
    </div>
</mat-dialog-actions>